import React from 'react'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-border bg-card">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
          <p className="text-sm text-muted-foreground">
            © {currentYear} VoIPBin. All rights reserved.
          </p>
          <div className="flex gap-4 text-sm text-muted-foreground">
            <a
              href="https://api.voipbin.net/docs/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Documentation
            </a>
            <a
              href="mailto:support@voipbin.net"
              className="hover:text-foreground transition-colors"
            >
              Support
            </a>
            <a
              href="https://voipbin.net/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Privacy
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
